import { PureComponent } from 'react';
import ScrollWrapper from 'components/ScrollWrapper';
import branch from 'hocs/branch';

import { isArrowUp, isArrowDown, isEnter } from '../constants';

class DropdownList extends PureComponent {
  scrollRef = React.createRef();

  state = { active: 1 };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = e => {
    if (!isArrowUp(e) && !isArrowDown(e) && !isEnter(e)) {
      return;
    }

    e.preventDefault();

    const { active } = this.state;
    const { options, closeList } = this.props;

    if (
      (isArrowUp(e) && active === 1) ||
      (isArrowDown(e) && active === options.length)
    ) {
      return closeList();
    }

    if (isEnter(e)) {
      const { onOptionClick } = this.props;

      onOptionClick(options[active - 1]);
      return closeList();
    }

    return this.handleArrowClick(isArrowUp(e));
  };

  handleArrowClick = direction => {
    const {
      getClientHeight,
      getScrollHeight,
      getScrollTop,
      scrollTo,
    } = this.scrollRef.current;

    const containerHeight = getClientHeight();
    const scrollHeight = getScrollHeight();
    const scrollPosition = getScrollTop();
    const scrollStep = scrollHeight / this.props.options.length;
    const nextActiveOption = direction ? -1 : 1;

    this.setState(
      prevState => ({
        active: prevState.active + nextActiveOption,
      }),
      () => {
        const activePosition = this.state.active * scrollStep;

        const maybeScroll = direction
          ? activePosition <= scrollPosition
          : activePosition > containerHeight + scrollPosition;

        if (maybeScroll) {
          const newScrollPosition = direction
            ? activePosition - scrollStep
            : activePosition - containerHeight;

          scrollTo(newScrollPosition);
        }
      }
    );
  };

  render() {
    const { onOptionClick, closeList, options } = this.props;
    return (
      <div className="Select-menu-outer">
        <ScrollWrapper
          type="thin"
          viewClassName="Select-scrollbar-box"
          ref={this.scrollRef}
        >
          {options.map((option, key) => (
            <div
              className={cx('Select-option', {
                active: this.state.active === key + 1,
              })}
              key={option.id}
              onMouseDown={() => {
                onOptionClick(option);
                closeList();
              }}
            >
              {option.name}
            </div>
          ))}
        </ScrollWrapper>
      </div>
    );
  }
}

export default branch(DropdownList);
